import {postMethod} from '~/api'

async function post(hotelId, request) {
    return await postMethod(`/api/hotelDescription/${hotelId}/roomType/swap`, request)
}

export {post}
